import script from "./InputSingleFile.vue?vue&type=script&setup=true&lang=ts"
export * from "./InputSingleFile.vue?vue&type=script&setup=true&lang=ts"

import "./InputSingleFile.vue?vue&type=style&index=0&id=6fe51507&lang=scss&scoped=true"

import exportComponent from "/var/www/fgc-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fe51507"]])

export default __exports__